import React from 'react';
import { Button } from '../../ui/button';
import { Plus, Edit, Trash2, TrendingUp } from 'lucide-react';

/**
 * Sales Area assignments table + empty state + tab navigation.
 */
const SalesAreaTable = ({
  salesAreaData,
  readOnly,
  onAdd,
  onEdit,
  onDelete,
  setActiveTab,
}) => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Sales Area Assignments</h3>
        <p className="text-sm text-gray-600">{salesAreaData.length} Sales Area(s) added</p>
      </div>
      {!readOnly && (
        <Button type="button" onClick={onAdd} className="bg-green-600 hover:bg-green-700" data-testid="add-sales-area-btn">
          <Plus className="w-4 h-4 mr-2" />
          Add Sales Area
        </Button>
      )}
    </div>

    {salesAreaData.length > 0 ? (
      <div className="bg-white rounded-lg border border-gray-200 overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Sales Org</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Dist. Channel</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Division</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Currency</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Credit Control</th>
              {!readOnly && <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {salesAreaData.map((sa, index) => (
              <tr key={index} className="hover:bg-gray-50" data-testid={`sales-area-row-${index}`}>
                <td className="px-4 py-3 font-medium">{sa.sales_org_id}</td>
                <td className="px-4 py-3">{sa.dist_channel_id}</td>
                <td className="px-4 py-3">{sa.division_id}</td>
                <td className="px-4 py-3">{sa.currency_code || '–'}</td>
                <td className="px-4 py-3">{sa.credit_control_area || '–'}</td>
                {!readOnly && (
                  <td className="px-4 py-3 text-right space-x-2">
                    <Button size="sm" variant="ghost" onClick={() => onEdit(index)} data-testid={`sales-area-edit-${index}`}>
                      <Edit className="w-4 h-4" />
                    </Button>
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => onDelete(index)}
                      className="text-red-600 hover:text-red-900"
                      data-testid={`sales-area-delete-${index}`}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed">
        <TrendingUp className="w-12 h-12 text-gray-400 mx-auto mb-3" />
        <p className="text-gray-600">No Sales Areas added yet</p>
        <p className="text-sm text-gray-500 mt-1">Click "Add Sales Area" to get started</p>
      </div>
    )}

    <div className="flex justify-between pt-4 border-t">
      <Button type="button" variant="outline" onClick={() => setActiveTab('company')}>
        ← Back to Company Code
      </Button>
      <Button type="button" onClick={() => setActiveTab('partner')} className="bg-green-600 hover:bg-green-700">
        Continue to Partner Functions →
      </Button>
    </div>
  </div>
);

export default SalesAreaTable;
